// Canaux de contact directs de Manrina — source unique (S73). Lus par la page
// « Nous contacter » et par la fiche « Pas encore déclaré ? » du dossier
// exposant, qui renvoie vers un humain sans rouvrir la porte « Aide & contact »
// (encore « Bientôt » dans Mon compte).
export const CONTACT_EMAIL = 'contact@manrina.fr'
export const WHATSAPP = '596696191366'
export const lienWhatsApp = (texte) =>
  `https://wa.me/${WHATSAPP}${texte ? `?text=${encodeURIComponent(texte)}` : ''}`
